/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Risks_C2aInputs */

const en_home_risks_c2a = /** @type {(inputs: Home_Risks_C2aInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read about the risks`)
};

/**
* | output |
* | --- |
* | "Read about the risks" |
*
* @param {Home_Risks_C2aInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_risks_c2a = /** @type {((inputs?: Home_Risks_C2aInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Risks_C2aInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_risks_c2a(inputs)
});